const API = {
    ENV_PROPS: '/register/api/v1/properties',
    VALIDATE_PIN: '/register/api/v1/registration/begin',
    PHONE_CODES_ENDPOINT: '/register/api/v1/codes/phonetypes',
    BUS_REL_ENDPOINT: '/register/api/v1/codes/relationshiptypeslong',
    SECURITY_QUESTIONS: '/register/api/v1/codes/securityquestions',
    VALIDATE_PROFILE: '/register/api/v1/registration/complete'
};

const DEFAULTMENU = {
    footer: {
        links: [
            {
                id: 'commonmenu-footer-link-privacy-and-security',
                target: '_blank',
                href: 'https://www.travelers.com/about-travelers/privacy-statements',
                label: 'Privacy & Security'
            },
            {
                id: 'commonmenu-footer-link-terms-of-service',
                target: '_blank',
                href: 'https://www.travelers.com/about-travelers/legal',
                label: 'Terms of Service'
            },
            {
                id: 'commonmenu-footer-link-producer-compensation-disclosure',
                target: '_blank',
                href: 'https://www.travelers.com/about-travelers/producer-compensation-disclosure',
                label: 'Producer Compensation Disclosure'
            }
        ]
    }
};

const TIMEOUT = {
    IDLE: 18 * 60 * 1000,
    WARNING: 3 * 60 * 1000
};

const VIEWPORT = {
    TABLET_MAX: 799
};

const EPHR_LOGIN_URL = 'https://www.travelers.com/business-insurance/services/premium-audit';

const COMMON_PASSWORD_ERROR =
    'The Password you entered is too commonly used. Please choose a more unique password.';

const HTTP = {
    CONTENT_TYPE: 'content-type',
    APP_JSON: 'application/json',
    SUCCESS_CODE: '0'
};

const RESPONSES = {
    ERROR_404: {
        error: {
            statusCode: '404',
            message: '404 - Response returned an error'
        }
    },
    ERROR_504: {
        error: {
            statusCode: '504',
            message: '504 - Request Error'
        }
    }
};

const FOCUS_ELEMENTS = 'a, link, button, selector, textarea, div[tabIndex], span[tabIndex]';

const REGION_KEYS = ['local', 'localhost', 'pa-selfservice-', 'premium-audit-ui'];

const ACTIONS = {
    UPDATE_ACCT_INFO: 'updateAcctInfo',
    RESET_STATE: 'resetState',
    SHOW_ERROR: 'showError',
    UPDATE_PASSWORD_INFO: 'updatePasswordInfo'
};

const STEPPER_TEXT = {
    FIRST_STEP: 'Confirm Policies',
    SECOND_STEP: 'Contact Information',
    THIRD_STEP: 'Create Profile',
    FOURTH_STEP: 'Access Premium Audit'
};

const STEP_STATUS = {
    COMPLETE: 'complete',
    CURRENT: 'current',
    INCOMPLETE: 'incomplete'
};

export {
    ACTIONS,
    API,
    COMMON_PASSWORD_ERROR,
    DEFAULTMENU,
    FOCUS_ELEMENTS,
    REGION_KEYS,
    HTTP,
    RESPONSES,
    TIMEOUT,
    VIEWPORT,
    EPHR_LOGIN_URL,
    STEPPER_TEXT,
    STEP_STATUS
};
